import { render } from "./AccountStatus.vue?vue&type=template&id=0bd8b4fe&scoped=true"
import script from "./AccountStatus.vue?vue&type=script&lang=js"
export * from "./AccountStatus.vue?vue&type=script&lang=js"

import "./AccountStatus.vue?vue&type=style&index=0&id=0bd8b4fe&scoped=true&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd8b4fe"]])

export default __exports__